import * as React from "react";
import "./App.scss";
import { Provider } from "react-redux";
import configureStore from "./store/configureStore";
import Toast from "./components/toast";
import Links from "./navigation/links";

// import { Route } from "react-router";
// import Layout from "./navigation1/Layout";
// import Home from "./scenes/Home";
// import Counter from "./scenes/Counter";
// import FetchData from "./scenes/FetchData";

// import "./custom.css";

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore({});

export default () => (
  //@ts-ignore
  <Provider store={store}>
    <div className="app">
      <Links />
      <Toast />
    </div>
  </Provider>
);
